import React, { useState, useEffect, useRef, useContext } from "react";
import { Dialog } from "primereact/dialog";

import Loader from "../../../../Base/Components/Loader/Loader";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid"
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";

import { getResumenActivos } from "../../../../API/Global/ActivosFijos/ActivosFijosRequest"; 

const ActivosConSubAct = ({
  showDialog,
  setShowDialog,
  selected,
  fecha
}) => {

  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [activosFijos, setActivosFijos] = useState([]);


  
  const getInfo = async () => {
    setLoading(true);
    const data = {
      IdActivo: selected?.IdActivo,
      Fecha: fecha
    }
    const a = await getResumenActivos(data);
    setActivosFijos(a);
    setLoading(false);
  };

  const colums = [
    {
      header: "IdActivo",
      headerEn: "",
      field: "IdActivo",
      className: "Xsmall",
      hide: userAuth.IdRol !== 1,
      frozen: true,
    },
    {
      header: "IdSubActivo",
      headerEn: "",
      field: "IdSubActivo",
      className: "Xsmall",
      hide: userAuth.IdRol !== 1,
      frozen: true,
    },
    {
      header: "Tipo",
      headerEn: "Type",
      field: "Type",
      className: "Xsmall",
    },
    {
      header: "Código Activo",
      headerEn: "Asset Code",
      field: "Codigo",
      Format: "Modal",
      className: "Xsmall",
      frozen: true,
    },
    {
      header: "Código SubAct",
      headerEn: "Asset Code",
      field: "CodigoSubActivo",
      frozen: true,
      className: "Xsmall",

    },
    {
      header: "Nombre",
      headerEn: "Asset Name",
      field: "Nombre",
      className: "large",
      frozen: true,
      Sumary: "count",
    },
    {
      header: "Marca",
      headerEn: "Brand",
      field: "Marca",
    },
    {
      header: "Modelo",
      headerEn: "Model",
      field: "Modelo",
    },
    {
      header: "Serie",
      headerEn: "Serial",
      field: "Serie",
    },
    {
      header: "Area",
      headerEn: "Area",
      field: "Area",
    },
    {
      header: "Comentario",
      headerEn: "Comment",
      field: "Comentario",
      className: "Xlarge",
    },
    {
      header: "Adquisicion",
      headerEn: "Acquisition",
      field: "FechaAdquisicion",
      Format: "Date",
    },
    {
      header: "Uso",
      headerEn: "Use",
      field: "FechaUso",
      Format: "Date",
    },
    {
      header: "Vida Util",
      headerEn: "Useful Life",
      field: "VidaUtil",
      className: "Xsmall",
      Format: "Center",
    },
    {
      header: "Valor",
      headerEn: "Value",
      field: "Valor",
      Format: "Currency",
      Sumary: "sum",
      className: "small",
    },
    {
      header: "V - R",
      headerEn: "V - R",
      field: "ValorAR",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      header: "Fecha Comenzo Depreciarse",
      headerEn: "Date Began to Depreciate",
      field: "FechaCominzaDepreciarse",
      className: "Xlarge",
      Format: "Date",
    },
    //DepreciacionMensual
    {
      header: "Dep. Mensual",
      headerEn: "Monthly Depreciation",
      field: "DepreciacionMensual",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
    // MesesUso
    {
      header: "Meses Uso",
      headerEn: "Months of Use",
      field: "MesesUso",
      className: "Xsmall",
      Format: "Center",
    },
    // DepreciacionAcumulada
    {
      header: "Dep. Acumulada",
      headerEn: "Accumulated Depreciation",
      field: "DepreciacionAcumulada",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
    //DepreciacionEjercicio
    {
      header: "Dep. Ejercicio",
      headerEn: "Depreciation Exercise",
      field: "DepreciacionEjercicio",
      className: "small",
      Sumary: "sum",
      Format: "Currency",
    },
    //SaldoPorDepreciar
    {
      header: "Saldo Por Depreciar",
      headerEn: "Balance to Depreciate",
      field: "SaldoPorDepreciar",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
    //DepreciacionAcumuladaFinBalance
    {
      header: "Dep. Acumulada Fin Balance",
      headerEn: "Accumulated Depreciation End Balance",
      field: "DepreciacionAcumuladaFinBalance",
      className: "large",
      Format: "Currency",
      Sumary: "sum",
    },
    //ValorLibros
    {
      header: "Valor Libros",
      headerEn: "Book Value",
      field: "ValorLibros",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "Xsmall",
      Format: "Estado",
      filter: false,
      frozen: true,
      alignFrozen: "right",
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
  ];

  const table = {
    key: "IdActivo",
    Columns: colums,
    Data: activosFijos,
    showModal: (e) => showModal(e),
  };

  
  const showModal = () => {};

  const onHide = () => {
    setShowDialog(false)
  };

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <div style={{width: '100vw'}}>
      <Dialog
        visible={showDialog}
        header={selected?.NombreActivo}
        modal
        className="modal__activos"
        onHide={onHide}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{height: '52vh'}}>
            <AgGrid table={table}/>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ActivosConSubAct;
